import queryString from "query-string";
import Cookies from "js-cookie";
import { COOKIE_REFERRAL } from "./config";

const params = queryString.parse(window.location.search);

if (!params.referralcode && Cookies.get(COOKIE_REFERRAL)) {
	params.referralcode = Cookies.get(COOKIE_REFERRAL);
} else if (params.referralcode) {
	Cookies.set(COOKIE_REFERRAL, params.referralcode, { expires: 1 });
}

export default params;
